<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Adjust Estimation Parameters</p>
          <button
            class="delete"
            aria-label="close"
            @click="close(true)">
          </button>
        </header>

        <v-form class="modal-card-body" :valid.sync="valid">
          <div 
            class="columns is-multiline title is-5"
            v-for="(section, i) in showParams" 
            :key="section.name">
            <div class="column is-full">
              <span>{{ section.name }}</span>
            </div>
            <div  
              v-for="param in section.fields"
              :key="param" 
              class="column is-half">
              <label class="label capitalize">
                {{ param.replaceAll("_", " ") }}*
              </label>
              <v-text-field 
                required
                :placeholder="`Enter ${param.replaceAll('_', ' ')}`"
                type="number"
                :value="estimation[param]"
                @input="updateParam(param, $event)">
              </v-text-field>
            </div>
            <div class="column is-full">
              <hr class="my-2" v-if="i != showParams.length - 1">
            </div>
          </div>
        </v-form>

        <footer class="modal-card-foot">
          <button 
            :disabled="!valid || saving"
            :class="{ 'is-loading': saving }"
            class="button is-primary" 
            @click.stop="saveChanges()">
            Save
          </button>
          <button 
            class="button" 
            @click.stop="close(true)">
            Cancel
          </button>
        </footer>

      </div>
    </div>
  </div>
</template>

<script>
import VTextField from '@/components/base/VTextField'
import VForm from '@/components/base/VForm'

export default {
  props: {
    value: {
      type: Boolean
    },
    estimation: {
      type: Object
    },
    showParams: {
      type: Array
    },
    saving:{
      type: Boolean,
      default: false
    }
  },
  components: { VTextField, VForm },
  data() {
    return {
      valid: true
    }
  },
  methods: {
    updateParam(field, value) {
      this.estimation[field] = value;
    },
    saveChanges() {
      this.$emit('update:saving', true);
      this.$emit('save-changes');
    },
    close() {
      this.$emit('input', false);
    }
  }
}
</script>

<style scoped>
.capitalize {
  text-transform: capitalize;
}
</style>
